import { createLogger } from "../../../utils/logger";

const logger = createLogger("storage");

type SerializableValue =
  | Record<string, unknown>
  | Array<unknown>
  | string
  | number
  | boolean
  | null;

type StorageAdapter = {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
};

function createStore(adapter: StorageAdapter) {
  return {
    get<T = unknown>(key: string): T | null {
      try {
        const raw = adapter.getItem(key);
        if (!raw) return null;
        return JSON.parse(raw) as T;
      } catch (error) {
        logger.warn(`Failed to parse storage key "${key}"`, error);
        return null;
      }
    },

    set(key: string, value: SerializableValue) {
      try {
        adapter.setItem(key, JSON.stringify(value));
      } catch (error) {
        logger.warn(`Failed to persist storage key "${key}"`, error);
      }
    },

    remove(key: string) {
      adapter.removeItem(key);
    }
  };
}

export const storage = {
  ...createStore(window.localStorage)
};

export const sessionStore = createStore(window.sessionStorage);
